import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import CustomButton from "Components/Custom/CustomButton";

interface AlertModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  icon?: React.ReactNode;
}

const AlertModal: React.FC<AlertModalProps> = ({
  isOpen,
  onCancel,
  onConfirm,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  isLoading = false,
  icon,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={onCancel}
      centered
      backdrop="static"
      size="md"
      className="p-3 overflow-hidden"
      contentClassName="br-12"
    >
      <ModalHeader toggle={onCancel} className="border-0 pb-0" />
      <ModalBody className="pt-0 pb-4 px-4 text-center">
        {icon && (
          <div className="mb-3 d-flex justify-content-center">{icon}</div>
        )}

        <h1 className="text-black2D fs-24 fw-semibold font-primary mb-2">
          {title}
        </h1>

        <p className="text-grey89 fs-14 fw-normal font-primary mb-4 px-2">
          {description}
        </p>

        <div className="d-flex gap-3">
          <CustomButton
            text={confirmText}
            className="bg-primary px-4 py-2 w-100"
            textClassName="fs-14"
            onClick={onConfirm}
            loading={isLoading}
          />
          <CustomButton
            text={cancelText}
            newClassName="w-100 px-4 py-2 border-0 justify-content-center bg-redF47"
            textClassName="text-redD2 fs-16"
            onClick={onCancel}
          />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default React.memo(AlertModal);
